// A MUNKANAP alapértelmezett kezdő-órája + a belőle származó időpont-előtöltés.
//
// MIÉRT KÜLÖN, FEATURE-FÜGGETLEN HELYEN: ugyanez a szám kell a megbeszélés-formnak (nap-kattintás → 08:00) és
// az üzenet-IDŐZÍTÉSNEK (a dialógus üresen indult, tehát a felhasználó minden alkalommal maga írta be az órát).
// A 2. fogyasztóval a konstans a közös rétegbe került; a megbeszélés-modul munkaidő-ABLAKA (06:00–22:00, a
// naptár-rács sávjai) továbbra is a feature-ben él (`features/meetings/business-hours.ts`) — az domén-szabály,
// ez pedig egy általános „reggel 8-kor kezdünk" default.
//
// A számítás a MEGJELENÍTÉSI zóna FAL-IDEJÉN megy (`YYYY-MM-DDTHH:mm` stringek) — nincs `Date`-aritmetika,
// tehát DST-váltás sem tudja elcsúsztatni.

/** A munkanap alapértelmezett kezdő-órája (előtöltésekhez). */
export const DEFAULT_START_HOUR = 8;

/** `YYYY-MM-DD` + a default óra → `YYYY-MM-DDTHH:mm`. */
export function atDefaultStartHour(dateInDisplayZone: string): string {
  return `${dateInDisplayZone}T${String(DEFAULT_START_HOUR).padStart(2, '0')}:00`;
}

/**
 * A KÖVETKEZŐ munkanap-kezdés a JÖVŐBEN: ma 08:00, ha az még nem múlt el — különben holnap 08:00.
 *
 * MIÉRT a „jövőbeli" szempont: az üzenet-időzítés validációja jövőbeli időpontot kér, tehát egy vak „ma 08:00"
 * előtöltés délután MÁR HIBÁS mezővel nyitná a dialógust (a felhasználó egy piros hibát látna, mielőtt bármit
 * tett volna). A hívó a megjelenítési zóna MAI dátumát és a mostani perceit adja — így a függvény tiszta.
 *
 * @param todayInDisplayZone a mai nap a megjelenítési zónában (`YYYY-MM-DD`)
 * @param nowMinutes eltelt percek a zóna szerinti éjfél óta
 */
export function nextDefaultStart(todayInDisplayZone: string, nowMinutes: number): string {
  if (nowMinutes < DEFAULT_START_HOUR * 60) return atDefaultStartHour(todayInDisplayZone);
  // Másnap: a dátum-léptetés a NAPTÁRI napon megy (UTC-ben számolva, hogy a DST ne csússzon bele — a
  // `YYYY-MM-DD` a zóna fal-dátuma, a következő nap pedig mindig +1 naptári nap).
  const next = new Date(`${todayInDisplayZone}T00:00:00Z`);
  next.setUTCDate(next.getUTCDate() + 1);
  return atDefaultStartHour(next.toISOString().slice(0, 10));
}
